import React, { useRef } from 'react';
import './ImportPolygonSection.css';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';

const ImportPolygonSection = ({ importPolygon }) => {

  const inputFileElement = useRef();

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    importPolygon(file);
    inputFileElement.current.value = '';
  };

  return (
    <div className='ImportPolygonSection_Btn'>
      <label onChange={handleFileUpload} htmlFor='formId'>
        <input type='file' ref={inputFileElement} id='formId' hidden />
        <SvgAF
          img={IconLoader.icon_import}
          hover={IconLoader.icon_import_hover}
        />
      </label>
    </div>
  )
};

export default ImportPolygonSection;